import { IClearAllFiltersStyle } from "../models/IClearAllFiltersStyle.js";

/**
 * WHITE LABEL STYLES for ClearAllFilters
 */
export const clearAllFiltersStyle: IClearAllFiltersStyle = {
	children: {

	},
	selectors: {

	},
};
